export default "__VITE_ASSET__269527fe__"